// src/components/layout/Breadcrumb.js
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';

const BreadcrumbContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 4px;
  max-width: 100%;
  margin-bottom: 16px;
`;

const BreadcrumbItemWrapper = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

const BreadcrumbLink = styled.div`
  color: ${(props) => props.theme.colors.primaryBlue};
  text-decoration: none;
  font-size: 15px;
  transition: opacity 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`;

const BreadcrumbText = styled.span`
  color: ${(props) => props.theme.colors.menuText};
  font-size: 15px;
  white-space: nowrap;
`;

const Separator = styled.span`
  color: #999;
  margin-left: 10px;
  margin-right: 5px;
  font-size: 15px;
  user-select: none;
`;

const Breadcrumb = ({ itemList }) => {
  const navigate = useNavigate();

  const handleBreadcrumbClick = (item, index) => {
    if (index === 0) {
      // Home link - navigate to home page
      navigate('/');
    } else if (item.state) {
      // Breadcrumb item with state - navigate with state
      navigate(item.link, item.state);
    } else {
      // Regular link without state
      navigate(item.link);
    }
  };

  return (
    <BreadcrumbContainer>
      {itemList.map((item, index) => (
        <BreadcrumbItemWrapper key={item.title}>
          {index === itemList.length - 1 ? (
            <BreadcrumbText>{item.title}</BreadcrumbText>
          ) : (
            <>
              <BreadcrumbLink
                onClick={() => handleBreadcrumbClick(item, index)}
              >
                {item.title}
              </BreadcrumbLink>
              {index < itemList.length - 1 && <Separator>/</Separator>}
            </>
          )}
        </BreadcrumbItemWrapper>
      ))}
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
